import React, { useState, useEffect, useRef } from 'react';
import './linktreeText.css';
import proximaLogo from '../Head_Logo_Pixel2.png';

const LINKS = [
    {
        label: "AstroMart NFT Marketplace",
        url: "https://www.astromart.gallery/"
    },
    {
        label: "Buy PROX Token",
        url: "https://vax.eliteness.network/#/swap"
    },
    {
        label: "Liquidity Pool",
        url: "https://vax.eliteness.network/#/pool"
    },
    {
        label: "Regular Staking Pool",
        url: "https://eliteness.network/farmlands/615"
    },
    {
        label: "Proxima Universe Discord",
        url: "https://discord.gg/GwjcGKCzz5"
    },
    {
        label: "Proxima Universe Telegram",
        url: "https://t.me/Proxima_Universe"
    },
    {
        label: "Proxima Universe Twitter",
        url: "https://x.com/ProximaUniverse"
    },
    {
        label: "Proxima Universe Bsky",
        url: "https://bsky.app/profile/proximauniverse.bsky.social"
    },
    {
        label: "Proxima Universe Medium Page",
        url: "https://medium.com/@ProximaUniverse"
    },
    {
        label: "Alephium Blockchain Official Website",
        url: "https://alephium.org/"
    },
    {
        label: "MultiVAC Blockchain Explorer - Powered by Proxima",
        url: "https://www.mtv-scout.com/"
    },
    {
        label: "MultiVAC Blockchain Official Website",
        url: "https://mtv.ac/"
    }
];

const LinkTreeText = () => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setIsVisible(entry.isIntersecting);
        });
        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);

    return (
        <div className="linktree-text" ref={ref}>
            <div className="linktree-red-glow-divider"></div>
            <p>
                <strong>Proxima Universe AstroLinks</strong>
            </p>
            <div className="linktree-red-glow-divider"></div>

            <img src={proximaLogo} alt="Proxima Logo" className="linktree-image" />

            <p>
                
            </p>

            <div className="linktree-red-glow-divider"></div>

            {LINKS.map(({ label, url }, i) => (
                <div key={url}>
                    <p>
                        <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="linktree-link"
                        >
                            <strong>{label}</strong>
                        </a>
                    </p>
                    {/* Only show a divider if not last item */}
                    {i < LINKS.length - 1 && <div className="linktree-red-glow-divider"></div>}
                </div>
            ))}
        </div>
    );
};

export default LinkTreeText;
